import * as fromDatatype from "../datatype-library/index";

export interface bl_cms_facilities_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_facilities_hdr_RowClass implements bl_cms_facilities_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
